import styled from "styled-components";
import { colors } from "../../../constants/styles/colors.constants";

export const SuggestedActionStyledWrapper = styled.span`
  margin: 0 5px;
  cursor: pointer;
  color: ${colors.link};
  font-weight: 600;
`;
